import classNames from 'classnames'
import type { FC } from 'react'
import styles from './ExpanderHeader.module.scss'
import type { ExpanderChildProps } from './types'

const ExpanderHeader: FC<ExpanderChildProps> = ({ children, className }) => {
  return <div className={classNames(styles['pintxo-expander-header'], className)}>{children}</div>
}

export default ExpanderHeader
